/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import T from 'i18n-react';
import moment from 'moment';
import { AButton, ATooltip } from 'components/Antd';
import CompanyPlaceholder from 'assets/img/placeholder/avatar-company.svg';
import { ReactComponent as ProductHomeIcon } from 'assets/icons/New/product-home-icon.svg';
import { ReactComponent as FactorySvg } from 'assets/icons/Nav/Supplier.svg';
import { ReactComponent as CheckCircle } from 'assets/icons/CheckCircle.svg';
import { ENTITIES } from 'views/DocumentManagement/components/SaveToModal/constants';
import classes from './SaveToModal.module.scss';

const EntityBlock = ({
  className,
  entity,
  fields,
  name,
  fromModal,
  unbox,
  data,
  isSelected,
  onSelectChanged,
}) => {
  const isProduct = entity === ENTITIES.PRODUCT;
  const tFields = fields || [];
  const productStatus = data?.status || 'active';
  const isProductActive = productStatus === 'active';
  const isProductInactive = productStatus === 'inactive';

  return (
    <div
      className={cn(
        classes.entityBlock,
        {
          [classes.isProduct]: isProduct,
          [classes.fromModal]: fromModal,
          [classes.unbox]: unbox,
        },
        className
      )}>
      <div className={classes.entityInnerWrapper}>
        {!isProduct && (
          <div>
            <span className={classes.entityName}>{name}</span>
          </div>
        )}
        <div className={classes.entityInner}>
          <div>
            {isProduct ? (
              <img src={data?.image || CompanyPlaceholder} alt="placeholder" />
            ) : (
              <>
                {tFields.map((obj, i) => {
                  return <span key={i}>{obj.title}</span>;
                })}
              </>
            )}
          </div>
          <div
            className={cn({
              [classes.productInfo]: isProduct,
            })}>
            {isProduct ? (
              <>
                <span className={classes.productName}>{name}</span>
                <span className={classes.productNumber}>{data?.itemNo}</span>
                <span
                  className={cn(classes.productStatus, {
                    [classes.active]: isProductActive,
                    [classes.inactive]: isProductInactive,
                  })}>
                  {isProductActive && <CheckCircle />}
                  <span>{productStatus}</span>
                </span>
                <span className={classes.productSupplier}>
                  <ATooltip
                    dark
                    title={'Supplier'}
                    placement="bottom"
                    overlayClassName={classes.tooltipOverlay}>
                    <span>
                      <ProductHomeIcon />
                    </span>
                  </ATooltip>
                  <span>{data?.supplier?.name || '/'}</span>
                </span>
                <span className={classes.productFactory}>
                  <ATooltip
                    dark
                    title={'Factory'}
                    placement="bottom"
                    overlayClassName={classes.tooltipOverlay}>
                    <span>
                      <FactorySvg />
                    </span>
                  </ATooltip>
                  <span>{data?.factory?.name || '/'}</span>
                </span>
              </>
            ) : (
              <>
                {tFields.map((obj, i) => {
                  return <span key={i}>{obj.value || '/'}</span>;
                })}
              </>
            )}
          </div>
        </div>
      </div>
      <div>
        <AButton
          ghost={!isSelected}
          htmlType="button"
          onClick={onSelectChanged}
          type={fromModal ? 'primary' : 'danger'}>
          {fromModal ? <>{isSelected ? 'Selected' : 'Select'}</> : <>Remove</>}
        </AButton>
      </div>
    </div>
  );
};

export default EntityBlock;
